































import { defineComponent, computed } from '@vue/composition-api';
import { Popup } from 'vant';

import { UploadTypeEnum } from '@/shared/tools/ocr/enum';

export default defineComponent({
  components: {
    Popup,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    uploadType: {
      default: UploadTypeEnum.SDKCamera,
    },
  },
  emits: ['input', 'confirm'],
  setup(props, context) {
    const showDialog = computed(() => props.value);
    const isCamera = computed((
    ) => props.uploadType === UploadTypeEnum.SDKCamera);
    const promptMessage = computed(() => (isCamera.value ? '若发起相册上传，已拍摄的信息将清空' : '若发起拍摄上传，已从相册上传的信息将清空'));
    const confirmBtn = computed(() => (isCamera.value ? '发起相册上传' : '发起拍摄上传'));

    const onClose = () => {
      context.emit('input', false);
    };
    const onConfirm = () => {
      context.emit('confirm');
    };

    return {
      showDialog,
      promptMessage,
      confirmBtn,

      onClose,
      onConfirm,
    };
  },
});

